import { CommonModule } from "@angular/common";
import { Inject, ModuleWithProviders, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import * as momentImport from "moment-timezone";

import {
    SpsDatepickerCalendarComponent,
    SpsDatepickerComponent,
    SpsDatepickerInputComponent,
    SpsDateRangePickerComponent,
    SpsDatetimeRangePickerComponent,
    SpsTimeInputComponent,
} from "../components/index";
import { SpsDatePipe, SpsDatetimePipe, SpsTimePipe } from "../pipes/index";
import { DATE_FORMAT, DATETIME_FORMAT, LOCALE, TIME_FORMAT, TIMEZONE } from "../tokens/index";
import { SpsSelectModule } from "./sps-select.module";

const moment = momentImport as any; // required for rollup to work without a TypeScript error

export interface DatetimeModuleConfig {
    dateFormat?: string;
    datetimeFormat?: string;
    locale?: string;
    timeFormat?: string;
    timezone?: string;
}

@NgModule({
    imports: [CommonModule, FormsModule, SpsSelectModule],
    declarations: [
        SpsDatepickerComponent,
        SpsDatepickerCalendarComponent,
        SpsDatepickerInputComponent,
        SpsDatePipe,
        SpsDateRangePickerComponent,
        SpsDatetimeRangePickerComponent,
        SpsDatetimePipe,
        SpsTimeInputComponent,
        SpsTimePipe
    ],
    exports: [
        SpsDatepickerComponent,
        SpsDatePipe,
        SpsDateRangePickerComponent,
        SpsDatetimeRangePickerComponent,
        SpsDatetimePipe,
        SpsTimeInputComponent,
        SpsTimePipe
    ]
})
export class SpsDatetimeModule {
    static forRoot(config: DatetimeModuleConfig = {}): ModuleWithProviders {
        return {
            ngModule: SpsDatetimeModule,
            providers: [
                {
                    provide: DATE_FORMAT,
                    useValue: config.dateFormat || "L"
                },
                {
                    provide: DATETIME_FORMAT,
                    useValue: config.datetimeFormat || "L LT"
                },
                {
                    provide: LOCALE,
                    useValue: config.locale || "en-US"
                },
                {
                    provide: TIME_FORMAT,
                    useValue: config.timeFormat || "LT"
                },
                {
                    provide: TIMEZONE,
                    useValue: config.timezone || "America/Chicago"
                }
            ]
        };
    }

    static forChild(): ModuleWithProviders {
        return { ngModule: SpsDatetimeModule };
    }

    constructor(
        @Inject(LOCALE) locale: string,
        @Inject(TIMEZONE) timezone: string
    ) {
        moment.locale(locale);
        moment.tz.setDefault(timezone);
    }
}
